import { Component, OnInit } from '@angular/core';
import { SharedDataService } from '@services/shared-data.service';

@Component({
    selector: 'app-embedded-global-cashflow-analysis',
    templateUrl: './embedded-global-cashflow-analysis.component.html',
    styleUrls: ['./embedded-global-cashflow-analysis.component.scss'],
    standalone: false
})
export class EmbeddedGlobalCashflowAnalysisComponent implements OnInit {
  constructor(
    private sharedDataService: SharedDataService,
  ) { }

  ngOnInit(): void {
    this.sharedDataService.hideDefaultNavigation();
    this.sharedDataService.embeddedMode$.next(true);
  }

}
